import script from "./StreaksIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./StreaksIndex.vue?vue&type=script&setup=true&lang=ts"

import "./StreaksIndex.vue?vue&type=style&index=0&id=425abeb9&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-425abeb9"]])

export default __exports__
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerGears});
